export default __webpack_public_path__ + "static/media/salt_logo.200de2fa.png";